/* Canned API responses for PREVIEW MODE. Keyed by a substring of the request
   URL. First match wins. Only used when localStorage 'wt_preview' === '1'. */

import { previewPlan, previewUser } from './preview.util';

const chars = [
  { id: 1, nickname: 'Sella Wren', primary_class_level: 3, race: 'Elf', primary_class: 'Ranger', alignment: 'Chaotic Good', strength: 12, dexterity: 17, constitution: 13, wisdom: 14, intelligence: 10, charisma: 11, map_name: 'Ashmorrow', is_retired: false, is_dead: false, game_details: [{ game_name: 'The Salt Road', map_id: 1, game_id: 1, is_active: true }] },
  { id: 2, nickname: 'Torvild Ash', primary_class_level: 6, race: 'Half-Orc', primary_class: 'Barbarian', alignment: 'Chaotic Neutral', strength: 18, dexterity: 13, constitution: 16, wisdom: 9, intelligence: 8, charisma: 12, map_name: 'Ashmorrow', is_retired: false, is_dead: false, game_details: [{ game_name: 'Blackwater Nights', map_id: 2, game_id: 2, is_active: false }] },
  { id: 3, nickname: 'Ondo Kesh', primary_class_level: 5, race: 'Human', primary_class: 'Fighter', alignment: 'Lawful Neutral', strength: 16, dexterity: 12, constitution: 15, wisdom: 11, intelligence: 10, charisma: 13, map_name: 'Ashmorrow', is_retired: false, is_dead: false, game_details: [{ game_name: 'The Salt Road', map_id: 1, game_id: 1, is_active: false }] },
  { id: 4, nickname: 'Bels Ardry', primary_class_level: 2, race: 'Halfling', primary_class: 'Rogue', alignment: 'Chaotic Neutral', strength: 8, dexterity: 18, constitution: 11, wisdom: 12, intelligence: 13, charisma: 14, map_name: 'Ashmorrow', is_retired: false, is_dead: false, game_details: [] },
  { id: 5, nickname: 'Maeve Dunn', primary_class_level: 4, race: 'Tiefling', primary_class: 'Warlock', alignment: 'Neutral Evil', strength: 9, dexterity: 14, constitution: 12, wisdom: 10, intelligence: 15, charisma: 17, map_name: 'Orberia', is_retired: true, is_dead: false, game_details: [] },
  { id: 6, nickname: 'Old Harrower', primary_class_level: 7, race: 'Dwarf', primary_class: 'Cleric', alignment: 'Lawful Good', strength: 14, dexterity: 8, constitution: 16, wisdom: 16, intelligence: 10, charisma: 12, map_name: 'Bluendia', is_retired: false, is_dead: true, game_details: [] },
];

const games = [
  { id: 1, Gamename: 'The Salt Road', partylevel: 4, Averagelevel: 4, numberOfPlayers: 3, map_name: 'Ashmorrow', map_id: 1, game_genre: 'Wilderness', FirstPlayed: '2025-05-02', JournalEntries: 6, active_characters: [{ character_id: 1, user_name: 'Maya T.', nickname: 'Sella', last_name: 'Wren', primary_class_level: 3, primary_class: 'Ranger', email: 'maya@wt.test' }, { character_id: 3, user_name: 'Jordan R.', nickname: 'Ondo', last_name: 'Kesh', primary_class_level: 5, primary_class: 'Fighter', email: 'jordan@wt.test' }, { character_id: 7, user_name: 'Ali P.', nickname: 'Garth', primary_class_level: 7, primary_class: 'Wizard', email: 'ali@wt.test' }, { user_name: 'open seat' }] },
  { id: 2, Gamename: 'Blackwater Nights', partylevel: 6, Averagelevel: 6, numberOfPlayers: 2, map_name: 'Ashmorrow', map_id: 2, game_genre: 'Intrigue', FirstPlayed: '2025-04-11', JournalEntries: 11, active_characters: [{ character_id: 2, user_name: 'Casey L.', nickname: 'Torvild', last_name: 'Ash', primary_class_level: 6, primary_class: 'Barbarian', email: 'casey@wt.test' }, { character_id: 8, user_name: 'Sam K.', nickname: 'Muri', primary_class_level: 5, primary_class: 'Bard', email: 'sam@wt.test' }] },
  { id: 3, Gamename: 'Debts of the Tide', partylevel: 4, Averagelevel: 5, numberOfPlayers: 0, map_name: 'Moonwharf', map_id: 3, game_genre: 'Heist', FirstPlayed: '2025-06-20', JournalEntries: 1, active_characters: [] },
];

const content = [
  // Created (published by preview user)
  { id: 1, content_title: 'Blackwater Inn', gamesystem: 'D&D 5e', type: 'Establishment', playtime: 2, partyaverage: '3–5', recommend_player: '1–4', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 999, status: 'published' },
  { id: 2, content_title: "The Apothecary's Debt", gamesystem: 'D&D 5e', type: 'Adventure', playtime: 4, partyaverage: '4–6', recommend_player: '3–6', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 999, status: 'published' },
  { id: 3, content_title: 'Ruins of Orberia', gamesystem: 'D&D 5e', type: 'Adventure', playtime: 6, partyaverage: '4–6', recommend_player: '3–5', map_name: 'Orberia', mapcode: 'ORB', citycode: null, created_by: 999, status: 'published' },
  { id: 4, content_title: 'Salt Road Caravan', gamesystem: 'Pathfinder 2e', type: 'Campaign', playtime: 14, partyaverage: '5–8', recommend_player: '4–6', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 999, status: 'published' },
  // Purchased (other authors)
  { id: 5, content_title: 'Siege of the Iron-Hide Herd', gamesystem: 'Pathfinder 2e', type: 'Campaign', playtime: 12, partyaverage: '5–8', recommend_player: '4–5', map_name: 'Orberia', mapcode: 'ORB', citycode: null, created_by: 42, status: 'published' },
  { id: 6, content_title: 'Tideglass Academy', gamesystem: 'D&D 5e', type: 'Establishment', playtime: 3, partyaverage: '3–5', recommend_player: '2–4', map_name: 'Bluendia', mapcode: 'BLU', citycode: null, created_by: 42, status: 'published' },
  { id: 7, content_title: 'The Drowned Bell', gamesystem: 'D&D 5e', type: 'Adventure', playtime: 6, partyaverage: '4–5', recommend_player: '4–5', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 17, status: 'published' },
  { id: 8, content_title: 'Vaults of Sar Orin', gamesystem: 'Pathfinder 2e', type: 'Adventure', playtime: 8, partyaverage: '4–6', recommend_player: '3–6', map_name: 'Orberia', mapcode: 'ORB', citycode: null, created_by: 17, status: 'published' },
  // Drafts (owned, unpublished)
  { id: 9, content_title: 'Emberfall Barracks', gamesystem: 'D&D 5e', type: 'Establishment', playtime: 2, partyaverage: '3–4', recommend_player: '1–4', map_name: 'Orberia', mapcode: 'ORB', citycode: null, created_by: 999, status: 'draft' },
  { id: 10, content_title: 'Wyrmspume Lighthouse', gamesystem: 'D&D 5e', type: 'Adventure', playtime: 5, partyaverage: '4–6', recommend_player: '3–5', map_name: 'Bluendia', mapcode: 'BLU', citycode: null, created_by: 999, status: 'draft' },
  { id: 11, content_title: 'Ash Bazaar Heist', gamesystem: 'Pathfinder 2e', type: 'Adventure', playtime: 4, partyaverage: '3–5', recommend_player: '3–4', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 999, status: 'draft' },
  { id: 12, content_title: 'Broken Halberd Outpost', gamesystem: 'D&D 5e', type: 'Campaign', playtime: 10, partyaverage: '5–7', recommend_player: '4–6', map_name: 'Ashmorrow', mapcode: 'ASH', citycode: null, created_by: 999, status: 'draft' },
];

const maps = [
  { map_name: 'Ashmorrow', map_id: 1, user_id: 999, image: 'Map not found', created_at: '2025-06-01', creator: { display_name: 'Preview GM' }, active_characters: 42, active_games: 7, establishments: 12, city_establishments: 3, adventures: 5, city_adventures: 1 },
  { map_name: 'Orberia', map_id: 2, user_id: 42, image: 'Map not found', created_at: '2025-04-14', creator: { display_name: 'Daybreak Collective' }, active_characters: 18, active_games: 3, establishments: 6, city_establishments: 0, adventures: 2, city_adventures: 0 },
  { map_name: 'Bluendia', map_id: 3, user_id: 42, image: 'Map not found', created_at: '2025-05-22', creator: { display_name: 'Halloran' }, active_characters: 27, active_games: 4, establishments: 9, city_establishments: 1, adventures: 3, city_adventures: 0 },
];

const downgrade = { should_show_warning: false, cleanup_required: false, from_plan: 'worldsmith', to_plan: 'worldsmith' };

const plan = previewPlan();

const subPlanFeatures = [
  'Join unlimited games', 'Create & publish modules', 'Community wiki access',
  'In-game journaling', 'AI generation tokens',
];
const mkPlan = (i: number, name: string, price: number, interval: 'month' | 'year') => ({
  id: i, stripe_index: i, price_id: `price_${interval}_${i}`, name, price, interval,
  description: `${name} tier — everything you need to ${i < 3 ? 'play' : 'build worlds'}.`,
  image: null, is_current_plan: i === 2,
  features: subPlanFeatures.slice(0, 2 + i),
});
const subscriptionPlans = {
  plans: {
    month: [mkPlan(1, 'Adventurer', 0, 'month'), mkPlan(2, 'Surveyor', 6, 'month'), mkPlan(3, 'Architect', 12, 'month'), mkPlan(4, 'Creator', 24, 'month')],
    year: [mkPlan(1, 'Adventurer', 0, 'year'), mkPlan(2, 'Surveyor', 60, 'year'), mkPlan(3, 'Architect', 120, 'year'), mkPlan(4, 'Creator', 240, 'year')],
  },
  current_subscription: { plan_id: 2, plan_name: 'Surveyor', stripe_price_id: 'price_month_2', interval: 'month', features: [] },
};

const subscriptionHistory = {
  res: [
    { plan: 'Adventurer', start_date: '2025-01-10T00:00:00Z', end_date: '2025-03-10T00:00:00Z', action: 'Subscribed' },
    { plan: 'Surveyor', start_date: '2025-03-10T00:00:00Z', end_date: '2025-09-01T00:00:00Z', action: 'Upgraded' },
  ],
};

// ---------------------------------------------------------------------------
// Marketplace preview fixtures (matches marketplace.models.ts / the DRF
// serializers those types mirror). Kept separate from the legacy fixtures
// above since these follow the new /api/v1/ shapes directly, with no `res`
// wrapper.
// ---------------------------------------------------------------------------

const daybreak = {
  id: 1, shop_name: 'Daybreak Collective', shop_slug: 'daybreak-collective', logo: null,
  banner: null, bio: 'Establishments and encounters for Orberia.', status: 'active',
  rating_avg: 4.6, rating_count: 80, is_storefront_visible: true, charges_enabled: true,
  terms_accepted_at: '2026-08-01T00:00:00Z', terms_version: '1.0', created_at: '2026-08-01T00:00:00Z',
};
const halloran = {
  id: 2, shop_name: 'Halloran', shop_slug: 'halloran', logo: null,
  banner: null, bio: 'Tales from the drowned duchy of Ashmorrow.', status: 'active',
  rating_avg: 4.8, rating_count: 302, is_storefront_visible: true, charges_enabled: true,
  terms_accepted_at: '2026-07-15T00:00:00Z', terms_version: '1.0', created_at: '2026-07-15T00:00:00Z',
};
const vessaCorr = {
  id: 3, shop_name: 'Vessa Corr', shop_slug: 'vessa-corr', logo: null,
  banner: null, bio: 'Campaigns and vault crawls set in Orberia.', status: 'active',
  rating_avg: 4.7, rating_count: 210, is_storefront_visible: true, charges_enabled: true,
  terms_accepted_at: '2026-06-20T00:00:00Z', terms_version: '1.0', created_at: '2026-06-20T00:00:00Z',
};
const previewVendors = [daybreak, halloran, vessaCorr];

const catEstablishment = { id: 4, slug: 'establishment', name: 'Establishment', attribute_schema: {}, parent: null };
const catCampaign = { id: 3, slug: 'campaign', name: 'Campaign', attribute_schema: {}, parent: null };
const catAdventure = { id: 2, slug: 'side-quest-adventure-arc', name: 'Side Quest / Adventure Arc', attribute_schema: {}, parent: null };
const previewCategories = [
  { id: 1, slug: 'one-shot-encounter', name: 'One Shot Encounter', attribute_schema: {}, parent: null },
  catAdventure, catCampaign, catEstablishment,
];

function previewListing(overrides: any) {
  return {
    id: 1, vendor: daybreak, category: catEstablishment.id, category_detail: catEstablishment,
    title: 'Untitled', slug: 'untitled', short_description: '', description: '',
    fulfillment_type: 'digital', listing_type: 'one_time', price: '5.00', currency: 'usd',
    license_type: null, ai_generated: false, ai_disclosure_percent: null,
    attributes: {}, status: 'published', cover_image: null, rating_avg: 4.5, rating_count: 10,
    created_at: '2026-09-01T00:00:00Z', updated_at: '2026-09-01T00:00:00Z',
    ...overrides,
  };
}

const previewListings = [
  previewListing({
    id: 1, vendor: halloran, category_detail: catEstablishment, title: 'Moonwharf Market', slug: 'moonwharf-market',
    short_description: 'Stalls, pickpockets, and a stall that sells maps of places that do not exist yet.',
    price: '5.00', cover_image: 'assets/images/Moonwharf.jpg', rating_avg: 4.9, rating_count: 302,
    attributes: { game_system: 'D&D 5e', biome: 'coast', playtime_hours: 2, party_average_level: 3, recommended_players: 4 },
    created_at: '2026-09-04T00:00:00Z',
  }),
  previewListing({
    id: 2, vendor: halloran, category_detail: catAdventure, title: 'The Drowned Bell', slug: 'the-drowned-bell',
    short_description: 'A flooded chapel rings on the hour and nobody will say why.',
    price: '9.00', cover_image: 'assets/images/Ashmorrow.jpeg', rating_avg: 4.9, rating_count: 302,
    attributes: { game_system: 'D&D 5e', biome: 'coast', playtime_hours: 6, party_average_level: 5, recommended_players: 4 },
    created_at: '2026-07-12T00:00:00Z',
  }),
  previewListing({
    id: 3, vendor: vessaCorr, category_detail: catCampaign, title: 'Siege of the Iron-Hide Herd', slug: 'siege-of-the-iron-hide-herd',
    short_description: 'A migrating herd becomes a siege engine. Three-act campaign with a hard last stand.',
    price: '14.00', cover_image: 'assets/images/im-home-img1.png', rating_avg: 4.8, rating_count: 210,
    attributes: { game_system: 'Pathfinder 2e', biome: 'plains', playtime_hours: 12, party_average_level: 7, recommended_players: 4 },
    created_at: '2026-09-01T00:00:00Z',
  }),
  previewListing({
    id: 4, vendor: daybreak, category_detail: catEstablishment, title: 'Emberfall Barracks', slug: 'emberfall-barracks',
    short_description: 'A free barracks drop-in. Drill sergeants, bunks, and a missing roster.',
    price: '0.00', cover_image: 'assets/images/im-home-img2.png', rating_avg: 4.2, rating_count: 38,
    attributes: { game_system: 'D&D 5e', biome: 'urban', playtime_hours: 2, party_average_level: 2, recommended_players: 4 },
    created_at: '2026-09-06T00:00:00Z',
  }),
  previewListing({
    id: 5, vendor: daybreak, category_detail: catEstablishment, title: "Cartographer's Rest", slug: 'cartographers-rest',
    short_description: 'Maps, tea, and a back room where blank vellum is never blank for long.',
    price: '4.00', cover_image: 'assets/images/im-home-img3.png', rating_avg: 4.6, rating_count: 80,
    attributes: { game_system: 'D&D 5e', biome: 'urban', playtime_hours: 2, party_average_level: 3, recommended_players: 4 },
    created_at: '2026-08-11T00:00:00Z',
  }),
];

const previewCartLine = (overrides: any) => ({
  id: 1, listing: 1, listing_detail: previewListings[0], quantity: 1,
  unit_price_snapshot: previewListings[0].price, saved_for_later: false,
  line_total: previewListings[0].price, added_at: '2026-09-10T00:00:00Z',
  ...overrides,
});
const previewCart = {
  id: 1,
  lines: [
    previewCartLine({}),
    previewCartLine({
      id: 2, listing: 3, listing_detail: previewListings[2], quantity: 1,
      unit_price_snapshot: previewListings[2].price, line_total: previewListings[2].price,
    }),
  ],
  subtotal: '19.00',
  item_count: 2,
  last_activity_at: '2026-09-10T00:00:00Z',
};

const previewOrders = [
  {
    id: 1,
    order_number: 'WT-2026-00042',
    subtotal: '19.00', tax_total: '0.00', discount_total: '0.00', total: '19.00',
    coupon: null,
    status: 'paid',
    lines: [
      {
        id: 1, listing: 1, listing_detail: previewListings[0],
        vendor: 1, vendor_detail: daybreak, quantity: 1,
        unit_price: previewListings[0].price,
      },
      {
        id: 2, listing: 3, listing_detail: previewListings[2],
        vendor: 1, vendor_detail: daybreak, quantity: 1,
        unit_price: previewListings[2].price,
      },
    ],
    created_at: '2026-09-12T00:00:00Z',
  },
  {
    id: 2,
    order_number: 'WT-2026-00039',
    subtotal: '4.00', tax_total: '0.00', discount_total: '0.00', total: '4.00',
    coupon: null,
    status: 'pending',
    lines: [
      {
        id: 3, listing: 5, listing_detail: previewListings[4],
        vendor: 1, vendor_detail: daybreak, quantity: 1,
        unit_price: previewListings[4].price,
      },
    ],
    created_at: '2026-09-02T00:00:00Z',
  },
];

const previewVendorMeUnonboarded = {
  id: 99, shop_name: '', shop_slug: 'preview-gm', logo: null, banner: null, bio: '',
  status: 'active', rating_avg: 0, rating_count: 0, is_storefront_visible: false,
  charges_enabled: false, terms_accepted_at: null, terms_version: '',
  created_at: '2026-09-01T00:00:00Z',
};

/**
 * `vendors/me` resolves to this so /marketplace/vendor-dashboard is reachable
 * in preview — the dashboard bounces any vendor missing shop_name,
 * terms_accepted_at or charges_enabled straight to onboarding, which made the
 * whole dashboard (listings, payouts, reviews) impossible to preview.
 * /marketplace/vendor-onboarding is still viewable directly; it renders a step
 * rather than redirecting. Point the `vendors/me` fixture back at
 * `previewVendorMeUnonboarded` to demo the onboarding flow instead.
 */
const previewVendorMeOnboarded = {
  id: 1, shop_name: 'Daybreak Collective', shop_slug: 'daybreak-collective',
  logo: null, banner: null, bio: 'Maps, modules and the odd cursed inn.',
  status: 'active', rating_avg: 4.6, rating_count: 80, is_storefront_visible: true,
  charges_enabled: true, terms_accepted_at: '2026-09-01T00:00:00Z', terms_version: '1.0',
  created_at: '2026-09-01T00:00:00Z',
};

const previewVendorReviews = [
  {
    id: 11, reviewer_display: 'Tomas K.', listing: 1, order_line: 4,
    subscription_plan: null, subscription: null, rating: 5,
    body: 'Ran it for four players over two sessions. The dock chase in act two landed perfectly.',
    is_hidden: false, vendor_response: '', vendor_responded_at: null,
    created_at: '2026-09-15T00:00:00Z',
  },
  {
    id: 12, reviewer_display: 'Wren', listing: 3, order_line: 5,
    subscription_plan: null, subscription: null, rating: 3,
    body: 'Good bones, but the stat block on page 6 contradicts the summary.',
    is_hidden: false,
    vendor_response: 'Good catch — corrected in v1.2, re-download any time.',
    vendor_responded_at: '2026-09-16T00:00:00Z',
    created_at: '2026-09-14T00:00:00Z',
  },
];

const previewConnectStatus = {
  charges_enabled: false, payouts_enabled: false, details_submitted: false,
  onboarded_at: null, reserve_active: true, reserve_percent: '15.00', reserve_graduates_at: null,
};

type Fixture = { test: RegExp; body: any; methods?: string[] };

const previewCreatedListing = previewListing({
  id: 999, vendor: previewVendorMeUnonboarded as any, title: 'Preview Draft Listing', slug: 'preview-draft-listing',
});

const MARKETPLACE_FIXTURES: Fixture[] = [
  { test: /api\/v1\/vendors\/me\/accept-terms/i, body: { ...previewVendorMeUnonboarded, shop_name: 'Preview Shop', terms_accepted_at: '2026-09-10T00:00:00Z', terms_version: '1.0' } },
  { test: /api\/v1\/vendors\/me\//i, body: previewVendorMeOnboarded },
  { test: /api\/v1\/vendors\/[a-z0-9-]+\/$/i, body: daybreak },
  { test: /api\/v1\/vendors\/?(\?|$)/i, body: previewVendors },
  { test: /api\/v1\/listing-categories/i, body: previewCategories },
  { test: /api\/v1\/license-types/i, body: [] },
  { test: /api\/v1\/listing-assets/i, body: { id: 1, listing: 999, format: 'image', file: '', version: 1, is_current: true, created_at: '2026-09-10T00:00:00Z' } },
  { test: /api\/v1\/listings\/\d+\/download/i, body: { success: true, preview: true } },
  // No real client_secret can be faked (Stripe.js validates it against
  // Stripe's own API) — this keeps the order summary readable in preview
  // while the actual payment form correctly stays empty.
  { test: /api\/v1\/checkout\/payment-intent/i, body: { order_id: 1, order_number: 'WT-PREVIEW01', total: previewCart.subtotal, client_secret: '' } },
  // Create/update return a single Listing object, not the browse array —
  // method-gated since these share a URL with the plain list/detail GETs.
  { test: /api\/v1\/listings\/?$/i, methods: ['POST'], body: previewCreatedListing },
  { test: /api\/v1\/listings\/\d+\/?$/i, methods: ['PATCH', 'PUT'], body: previewCreatedListing },
  { test: /api\/v1\/listings\/\d+\/?$/i, body: previewListings[0] },
  { test: /api\/v1\/listings/i, body: previewListings },
  { test: /api\/v1\/cart\/lines\/\d+\/save-for-later/i, body: previewCart },
  { test: /api\/v1\/cart\/lines\/\d+/i, body: previewCart },
  { test: /api\/v1\/cart\/lines/i, body: previewCart },
  { test: /api\/v1\/cart/i, body: previewCart },
  { test: /api\/v1\/orders\/\d+/i, body: previewOrders[0] },
  { test: /api\/v1\/orders/i, body: previewOrders },
  { test: /api\/v1\/favorites/i, body: [] },
  { test: /api\/v1\/reviews\/\d+\/respond/i, body: { ...previewVendorReviews[0], vendor_response: 'Thanks for playing!', vendor_responded_at: '2026-09-23T00:00:00Z' } },
  { test: /api\/v1\/reviews\/?\?.*vendor=/i, body: previewVendorReviews },
  { test: /api\/v1\/reviews/i, body: [] },
  { test: /api\/v1\/subscription-plans/i, body: [] },
  { test: /api\/v1\/subscriptions/i, body: [] },
  { test: /api\/v1\/follows/i, body: [] },
  { test: /api\/v1\/reports/i, body: [] },
  { test: /api\/v1\/coupons/i, body: [] },
  { test: /api\/v1\/stripe\/connect\/onboarding-link/i, body: { url: window.location.origin + '/marketplace/vendor-onboarding' } },
  { test: /api\/v1\/stripe\/connect\/account-status/i, body: previewConnectStatus },
];

const FIXTURES: Fixture[] = [
  ...MARKETPLACE_FIXTURES,
  { test: /api\/user\/profile\//i, body: previewUser() },
  { test: /Get\/userdetails\/byuserid/i, body: previewUser() },
  { test: /api\/invitation\/count\//i, body: { count: 3 } },
  { test: /character\/Getcharacterdetailsbyuserid/i, body: { character_details: chars } },
  { test: /gamemaster\/Getgamemaster/i, body: { gamemasterdetails: games } },
  { test: /gameuser\/GameDetailsByGameId|GameDetailsByGameId/i, body: { res: games[0] } },
  { test: /api\/party\/get-party-by-game/i, body: { res: { active_characters: games[0].active_characters } } },
  { test: /Getcharacterdetailsbygameid/i, body: { res: games[0].active_characters } },
  { test: /api\/content\/(getlist-userid|all)\//i, body: { res: content } },
  { test: /getmaps\/GetMaplistbyUseridAPI|Getmaplist/i, body: { res: maps } },
  { test: /getDowngradeStatus|downgrade.*status|subscription-downgrade/i, body: downgrade },
  { test: /api\/subscriptions\/plans/i, body: subscriptionPlans },
  { test: /api\/subscriptions\/history|subscription.*history/i, body: subscriptionHistory },
  { test: /subscription.*current|getCurrentSubscription|current-subscription/i, body: plan },
  { test: /Invitation\/invitationbystatus\/PENDING/i, body: { Invitation_list: [
    { id: 101, game_id: 1, gamename: 'The Salt Road', gameimage: null, game_master_display_name: 'Halloran', averageLevel: 4, playersInvited: 3, datetime: '2026-09-02', partyLevel: 4 },
    { id: 102, game_id: 2, gamename: 'Blackwater Nights', gameimage: null, game_master_display_name: 'Maya T.', averageLevel: 6, playersInvited: 2, datetime: '2026-09-05', partyLevel: 6 },
  ] } },
  { test: /Invitation\/invitationbystatus\/ACCEPTED/i, body: { Invitation_list: [
    { id: 88, game_id: 3, gamename: 'Debts of the Tide', gameimage: null, game_master_display_name: 'Preview GM', datetime: '2026-08-12', status: 'ACCEPTED' },
    { id: 89, game_id: 1, gamename: 'The Salt Road', gameimage: null, game_master_display_name: 'Halloran', datetime: '2026-07-30', status: 'REJECTED' },
  ] } },
  { test: /Invitation\/invitationbystatus/i, body: { Invitation_list: [] } },
  { test: /api\/get-pending-invitations/i, body: { invitations: [
    { invitation_id: 201, map_name: 'Ashmorrow', map_image: null, invited_at: '2026-09-08T12:00:00Z', invited_by: 42 },
  ] } },
  { test: /gamesystem\//i, body: { res: [] } },
];

/** Return a canned body for a request URL/method, or undefined to let it pass through.
 * `method` is optional for backwards compatibility with existing callers —
 * fixtures with a `methods` filter only match when it's provided and matches. */
export function previewFixture(url: string, method?: string): any | undefined {
  const upperMethod = method?.toUpperCase();
  const hit = FIXTURES.find((f) => {
    if (!f.test.test(url)) return false;
    if (f.methods && (!upperMethod || !f.methods.includes(upperMethod))) return false;
    return true;
  });
  return hit ? hit.body : undefined;
}
